import { replaceNbsp } from "../../../../utils";

export default function IncutRenderer({
  data,
  className,
}: {
  data: {
    text?: string;
  };
  className?: string;
}) {
  try {
    const { text } = data;

    return (
      <article className="widget incut">
        <div className="widget__body incut__body">
          {text && <p className="incut__text">{replaceNbsp(text)}</p>}
        </div>
      </article>
    );
  } catch (error) {
    console.info(`Не удалось отобразить виджет Incut: ${error}`);
    return <></>;
  }
}
